import { parsePath, redirect, } from "react-router-dom";

/**
 * Prevents cyclic redirects
 */
export function redirectSafe(path: string, requestUrl = window.location.href, comparePath?: string,) {
  const targetPath = comparePath ?? parsePath(path,).pathname ?? path;
  if (!parsePath(requestUrl,).pathname?.includes(targetPath,)) {
    return redirect(path,);
  }
  return null;
}
